import axios from 'axios';

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

import React, { useEffect, useState } from 'react';

import { toast } from 'react-toastify';

import { useAuth } from '@src/contexts/authContext';

const url = `${process.env.REACT_APP_API_URL}`;

export default function EditSkillItemNurse({
  openModals,
  setOpenModals,
  fetchData,
}) {
  const { auth } = useAuth();
  const [skillItem, setSkillItem] = useState(null);
  const [preferenceItem, setPreferenceItem] = useState(null);

  useEffect(() => {
    const fetchDataAsync = async () => {
      if (!openModals) return;

      try {
        const [skillRes, prefRes] = await Promise.all([
          axios.get(`${url}/admin/skill-items/${openModals}`, {
            headers: { Authorization: `Bearer ${auth.idToken}` },
          }),
          axios.get(`${url}/preferences`, {
            headers: { Authorization: `Bearer ${auth.idToken}` },
          }),
        ]);

        const preference = prefRes.data.find(
          (p) => p?.extended_item?.id === openModals,
        );

        setSkillItem(skillRes.data);
        setPreferenceItem(preference);
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataAsync();
  }, [auth.idToken, openModals]);

  const handlePost = async () => {
    if (!skillItem) return;

    const skillPayload = {
      item: skillItem?.item,
      roles: skillItem?.roles,
    };

    const preferencePayload = {
      item: skillItem?.item,
      role: skillItem?.roles,
      extended_item: {
        id: skillItem?._id,
        model_name: 'SkillItem',
      },
    };

    try {
      await Promise.all([
        axios.put(`${url}/admin/skill-items/${openModals}`, skillPayload, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.idToken}`,
          },
        }),

        preferenceItem &&
          axios.put(
            `${url}/preferences/${preferenceItem._id}`,
            preferencePayload,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${auth.idToken}`,
              },
            },
          ),
      ]);

      toast.success('Item updated successfully', {
        position: 'top-center',
        autoClose: 2000,
      });

      fetchData();
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || 'Update failed', {
        position: 'top-center',
        autoClose: 2000,
      });
    }
  };

  return (
    <Dialog
      maxWidth='lg'
      fullwidth
      open={openModals}
      onClose={() => setOpenModals(false)}
    >
      <DialogTitle>Edit item</DialogTitle>
      <DialogContent>
        <Box flex={1} mr={1}>
          <Typography fontFamily='Poppins'>Name*</Typography>
          <TextField
            fullWidth
            variant='outlined'
            placeholder='Enter name'
            sx={{
              '& .MuiOutlinedInput-root': { borderRadius: '6px' },
              mt: '5px',
              width: '400px',
            }}
            value={skillItem?.item || ''}
            onChange={(e) =>
              setSkillItem({ ...skillItem, item: e.target.value })
            }
          />
          <Typography fontSize={12} color='gray' mt={3}>
            Please also edit on Preference!
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ textTransform: 'none' }}
          onClick={() => setOpenModals(false)}
          color='secondary'
        >
          Cancel
        </Button>
        <Button
          sx={{ textTransform: 'none' }}
          color='primary'
          onClick={() => {
            handlePost();
            setOpenModals(false);
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
